export class BuscarPersonaPlantilla{
    idPersona: number;
    tipoDocumento: number;
    numeroDocumento: string;
    primerApellido: string;
    fechaExpedicion: string;
    tipoPersona: string;
    ramo: number;

    inicializarPlantilla(){
        this.idPersona=0;
        this.tipoDocumento=null;
        this.numeroDocumento="";
        this.primerApellido="";
        this.tipoPersona="";
        this.fechaExpedicion="";
        this.ramo=0;
    }

    esValido(){
        if(!this.tipoDocumento || this.numeroDocumento=="" || this.primerApellido=="")
            return false;
        return true;
    }

    constructor(){
        this.inicializarPlantilla();
    }
}